document.addEventListener("DOMContentLoaded", function () {
  const deliveryTimeElements = document.querySelectorAll(".delivery-time");

  deliveryTimeElements.forEach(function (element) {
    const currentDate = new Date();
    const delayDays = parseInt(element.dataset.deliveryTime, 10) || 20;
    const deliveryDate = calculateDeliveryDate(currentDate, delayDays);

    const dateElement = element.querySelector(".delivery-date");
    if (dateElement) {
      dateElement.textContent = formatDate(deliveryDate);
    }
  });

  /**
   * Calc the delivery date based on the current date and the delay days.
   */
  function calculateDeliveryDate(currentDate, delayDays) {
    const isFriday = currentDate.getDay() === 5;
    const currentHour = currentDate.getHours();
    console.log("currentHour", currentHour);
    let deliveryDate;

    if (isFriday) {
      // if it's Friday
      if (currentHour >= 16) {
        deliveryDate = addBusinessDays(currentDate, delayDays + 2); // delivery on Tuesday
      } else {
        deliveryDate = addBusinessDays(currentDate, delayDays + 1); // delivery on Monday
      }
    } else {
      // Dias normais
      if (currentHour >= 16) {
        deliveryDate = addBusinessDays(currentDate, delayDays + 1); // after 16h, add 1 day
      } else {
        deliveryDate = addBusinessDays(currentDate, delayDays);
      }
    }

    return deliveryDate;
  }

  /**
   * adds business days to a date.
   */
  function addBusinessDays(date, days) {
    let count = 0;
    let newDate = new Date(date);

    while (count < days) {
      newDate.setDate(newDate.getDate() + 1);
      // exclude weekends
      if (newDate.getDay() !== 0 && newDate.getDay() !== 6) {
        count++;
      }
    }

    return newDate;
  }

  /**
   * Formats a date to a string in the format "dd.mm.yyyy".
   */
  function formatDate(date) {
    const day = date.getDate().toString().padStart(2, "0");
    const month = (date.getMonth() + 1).toString().padStart(2, "0");
    const year = date.getFullYear();

    return `${day}.${month}.${year}`;
  }
});
